module.exports = __webpack_public_path__ + "img/step09_a_basket_basic_connect_left_right_brackets_Juliol2023.79e35252.png";